/* FAQ questions unfold (and fold back) slowly instead of jumping open. */
(function () {
  if (window.ysFaqAccordion) return;
  window.ysFaqAccordion = true;

  var DURATION = 700;
  var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

  function heightWhen(item, open) {
    var was = item.open;
    item.open = open;
    var height = item.offsetHeight;
    item.open = was;
    return height;
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.faq-accordion__item > summary');
    if (!summary) return;
    var item = summary.parentElement;
    if (!item.animate) return;
    event.preventDefault();

    var start = item.offsetHeight;
    if (item.ysAnimation) item.ysAnimation.cancel();
    // Closed, or folding back right now = open it; otherwise fold it.
    var opening = !item.open || item.classList.contains('is-closing');
    var end = heightWhen(item, opening);

    item.open = true;
    item.classList.toggle('is-closing', !opening);
    item.style.overflow = 'hidden';

    var animation = item.animate({ height: [start + 'px', end + 'px'] }, { duration: DURATION, easing: EASING });
    item.ysAnimation = animation;
    animation.onfinish = function () {
      item.ysAnimation = null;
      item.open = opening;
      item.classList.remove('is-closing');
      item.style.overflow = '';
    };
  });
})();
